import { createContext, useContext } from 'react'
import type { SessionInfo } from './api'

export type SessionState =
  | { status: 'checking' }
  | { status: 'signed-out'; error?: string }
  | { status: 'signed-in'; session: SessionInfo }

export type SessionContextValue = {
  state: SessionState
  signedIn: (session: SessionInfo) => void
  signOut: () => Promise<void>
}

export const SessionContext = createContext<SessionContextValue | null>(null)

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext)
  if (!value) throw new Error('useSession needs a SessionProvider above it.')
  return value
}
